import { useState } from 'react';
import { Paginator } from './Paginator';
import { PAGE_SIZE, fmtKc, pctChange } from './k2utils';

const Pct = ({ v }) => (v == null ? <span className="text-[#94A3B8]">—</span> : (
  <span className={v >= 0 ? 'text-[#16A34A]' : 'text-[#DC2626]'}>{v >= 0 ? '+' : ''}{v.toFixed(1)} %</span>
));

export const SimpleTable = ({ columns, rows, testId, rowKey, onRowClick }) => {
  const [page, setPage] = useState(0);
  const safePage = Math.min(page, Math.max(0, Math.ceil(rows.length / PAGE_SIZE) - 1));
  const visible = rows.slice(safePage * PAGE_SIZE, (safePage + 1) * PAGE_SIZE);
  return (
    <div data-testid={testId}>
      <div className="overflow-x-auto rounded-xl border border-[#E2E8F0]">
        <table className="w-full text-sm">
          <thead className="bg-[#F8FAF8] text-[#57534E]">
            <tr>{columns.map((c) => <th key={c.key} className={`px-3 py-2 font-semibold whitespace-nowrap ${c.num ? 'text-right' : 'text-left'}`}>{c.label}</th>)}</tr>
          </thead>
          <tbody>
            {visible.length === 0 && (
              <tr><td colSpan={columns.length} className="px-3 py-8 text-center text-[#94A3B8]" data-testid={`${testId}-empty`}>Žádná data pro zvolené období</td></tr>
            )}
            {visible.map((r, i) => (
              <tr key={rowKey ? rowKey(r) : i} onClick={onRowClick ? () => onRowClick(r) : undefined}
                className={`border-t border-[#F1F5F1] hover:bg-[#F0FDF4]/50 transition-colors ${onRowClick ? 'cursor-pointer' : ''}`} data-testid={`${testId}-row`}>
                {columns.map((c) => (
                  <td key={c.key} className={`px-3 py-2 ${c.num ? 'text-right tabular-nums whitespace-nowrap' : ''} ${c.className || ''}`}>
                    {c.render ? c.render(r) : r[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Paginator page={safePage} total={rows.length} pageSize={PAGE_SIZE} onPage={setPage} testId={`${testId}-pager`} />
    </div>
  );
};

const kc = (key) => (r) => fmtKc(r[key]);
const val = (v, r) => (r.count ? v : fmtKc(v));

export const COMPARE_COLUMNS = [
  { key: 'name', label: 'Ukazatel', className: 'font-medium text-[#1C1917]' },
  { key: 'cur', label: 'Aktuální období', num: true, render: (r) => val(r.cur, r) },
  { key: 'prev', label: 'Předchozí období', num: true, render: (r) => val(r.prev, r) },
  { key: 'diff', label: 'Rozdíl', num: true, render: (r) => val(r.cur - r.prev, r) },
  { key: 'pct', label: 'Rozdíl %', num: true, render: (r) => <Pct v={pctChange(r.cur, r.prev)} /> },
];

export const DAY_COLUMNS = [
  { key: 'date', label: 'Datum', render: (r) => r.label, className: 'font-medium' },
  { key: 'b290', label: 'Výdeje 290', num: true, render: kc('b290') },
  { key: 'b291', label: 'Výdeje 291', num: true, render: kc('b291') },
  { key: 'moves', label: 'Pohyby celkem', num: true, render: kc('moves'), className: 'font-semibold' },
  { key: 'losses', label: 'Ztráty NES', num: true, render: kc('losses'), className: 'text-[#DC2626]' },
  { key: 'docs', label: 'Dokladů', num: true },
];

export const WEEK_COLUMNS = [
  { key: 'label', label: 'Týden', className: 'font-medium whitespace-nowrap' },
  ...DAY_COLUMNS.slice(1),
  { key: 'delta', label: 'Pohyby vs. předch. týden', num: true, render: (r) => <Pct v={r.delta} /> },
];
